import React, { Component } from "react";
import { connect } from "react-redux";
import LocaleStrings from "Languages";

class GenerateBadgeHeader extends Component {
  constructor(props) {
    super(props);
  }

  /**
   * Badge search by input
   */
  onSearchUser = (event) => {
    var searchText = event.target.value;
    this.props.setSearch(searchText);
  };

  render() {
    let { search, badgeFor } = this.props;

    return (
      <div className="badge-generate-header" style={{ height: 87 }}>
        {badgeFor === "choose_attendees" ? (
          <input
            className="form-control badge-custom-search"
            placeholder={`${
              LocaleStrings.search
            } - ${LocaleStrings.search_info.replace("#count", 3)}`}
            type="search"
            value={search}
            onChange={this.onSearchUser}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
  };
}

export default connect(mapStateToProps, {})(GenerateBadgeHeader);
